import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { RememberService } from '../../../core/services/remember.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-consignment-plans-delivery-settings',
  templateUrl: './consignment-plans-delivery-settings.component.html',
  styleUrls: ['./consignment-plans-delivery-settings.component.css']
})
export class ConsignmentPlansDeliverySettingsComponent implements OnInit {
    public edit?: Edit;

    public selectListPortalUsers: PortalUserItem[] = [];

    public selectListStockLocations: Item[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService, private rememberService: RememberService) {

    }

    private async loadEdit() {
        this.edit = (await this.datatask.Post(1692));
    }

    private async loadUsers() {
        this.selectListPortalUsers = await this.datatask.Post(1758);
    }

    private async loadStockLocations() {
        this.selectListStockLocations = await this.datatask.Post(1718);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                Promise.all([
                    this.rememberService.remember('consignmentplansdelivery.portal_user_keyno', this.edit.portal_user_keyno),
                    this.rememberService.remember('consignmentplansdelivery.stocklocation_keyno', this.edit.stocklocation_keyno)
                ]).then(() => {
                    this.stateService.back();
                    Promise.resolve();
                });
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadUsers();
        this.loadStockLocations();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    error_code: string;
    error_message: string;
    order_internal_no: string;
    delivery_button_label: string;
    portal_user_keyno: string;
    printer: string;
    reportdef_keyno: string;
    reportdef_keyno_waybill: string;
    labour_no: string;
    labour_name: string;
    stocklocation_keyno: string;
    stocklocation_name: string;
    delivery_note: string;
    delivery_information: string;
    is_last: string;
    consignment_keyno: string;
}

interface PortalUserItem {
    portal_user_keyno: string;
    user_name: string;
}
